import React from 'react';
import styled from 'styled-components';
import * as StepperTypes from '.';

export const ProgressHeader = ({ steps, activeStep }: StepperTypes.Header) => {
    const percent = (100 / steps.length) * (activeStep + 1);
    return (
        <div>
            <div className="d-flex mx-2">
                <h6 className="w-50 mb-2">{steps[activeStep].name}</h6>
                <h6 className="w-50 mb-2 text-right">Step {activeStep + 1} of {steps.length}</h6>
            </div>
            <ProgressWrapper>
                <div
                    className="progress-bar bg-success"
                    role="progressbar"
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    style={{ width: `${percent}%` }}
                />
            </ProgressWrapper>
        </div>
    );
}

export default ProgressHeader;

const ProgressWrapper = styled.div.attrs(() => ({
    className: 'progress progress-stepper mb-2 rounded-0',
}))`
     &.progress-stepper {
        height: 4px;
     }
`;